<template>
  <div id="cadastro">
    <div id="voltar">
      <h4>Cadastrar Tarefa</h4>
      <button @click.prevent="fecharForm()">
        <img src="@/assets/Frame 523.png" />
      </button>
    </div>
    <form class="form">
      <div id="campos-form">
        <section id="esquerda">
          <!-- Campos existentes mantidos -->
          <div class="mb-3">
            <label
              for="exampleFormControlInput1"
              class="form-label"
              >Título*</label
            >
            <HelpIcon :texto="textosAjuda[0]" />
            <input
              type="text"
              class="form-control"
              v-model="tarefa.titulo"
              required
            />
          </div>
          <div class="mb-3">
            <label
              for="exampleFormControlTextarea1"
              class="form-label"
              >Descrição*</label
            >
            <HelpIcon :texto="textosAjuda[1]" />
            <textarea
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="1"
              v-model="tarefa.descricao"
              required
            ></textarea>
          </div>
          <div class="mb-3">
            <label
              for="modalidade-execucao"
              class="form-label"
              >Prioridade*</label
            >
            <HelpIcon :texto="textosAjuda[4]" />
            <select
              id="modalidade-execucao"
              class="form-select"
              v-model="tarefa.prioridade.id"
              required
            >
              <option
                v-for="prioridade in prioridades"
                :value="prioridade.id"
                :key="prioridade.id"
              >
                {{ formatarEnum(prioridade.prioridadeTarefa) }}
              </option>
            </select>
          </div>
        </section>
        <section id="direita">
          <div id="datas">
            <div class="mb-3">
              <label
                for="dataInicio"
                class="form-label"
                >Data de Início</label
              >
              <HelpIcon :texto="textosAjuda[2]" />
              <input
                type="datetime-local"
                id="dataInicio"
                class="form-control"
                v-model="tarefa.dataInicio"
              />
            </div>

            <div class="mb-3">
              <label
                for="dataInicio"
                class="form-label"
                >Data de Fim</label
              >
              <HelpIcon :texto="textosAjuda[3]" />
              <input
                type="datetime-local"
                id="dataInicio"
                class="form-control"
                v-model="tarefa.dataFim"
                required
              />
            </div>
          </div>

          <div class="mb-3">
            <label
              for="tempoEstimado"
              class="form-label"
              >tempo estimado(Em Horas)*</label
            >
            <HelpIcon :texto="textosAjuda[8]" />
            <input
              type="number"
              id="tempoEstimado"
              class="form-control"
              v-model="tempoEstimado"
            />
          </div>

          <!-- Seção de Atividade Vinculada - Corrigida -->
          <div class="mb-3">
            <label
              for="atividade-vinculada"
              class="form-label"
              >Atividade Vinculada</label
            >
            <HelpIcon :texto="textosAjuda[6]" />
            <div
              style="
                display: flex;
                justify-content: space-between;
                width: 100%;
                align-items: center;
                gap: 10px;
              "
            >
              <select
                id="atividade-vinculada"
                class="form-select"
                v-model="tarefa.atividadeId"
                @change="onAtividadeChange"
              >
                <option value="">Selecione uma atividade</option>
                <option
                  v-for="atividade in atividadesAcao"
                  :value="atividade.id"
                  :key="atividade.id"
                >
                  {{ atividade.nome }}
                </option>
              </select>
              <button
                id="remover-atividade"
                v-if="tarefa.atividadeId"
                @click.prevent="removerAtividadeVinculada"
              >
                Remover
              </button>
            </div>
          </div>
        </section>
      </div>
      <div id="botoes">
        <button
          id="salvar"
          type="button"
          @click.prevent="confirmacaoInicial('salvar')"
        >
          Salvar
        </button>
        <button
          type="button"
          id="enviar"
          @click.prevent="confirmacaoInicial('enviar')"
        >
          Cadastrar
        </button>
      </div>
    </form>
  </div>
  <Aviso
    :sucesso="sucesso"
    :texto="texto"
    @fecharModal="((aviso = false), sucesso == true ? router.back() : null)"
    v-if="aviso"
  ></Aviso>
  <ModalDeConfirmacao
    @confirmacao="confirmacao"
    v-if="confirmacaoView == true"
    :texto="texto"
  ></ModalDeConfirmacao>
</template>

<script setup>
import { onMounted, ref, computed, onBeforeUnmount } from "vue";
import HelpIcon from "@/components/common/HelpIcon.vue";
import { formatarEnum } from "@/utils/FormatarEntradas";
import atividadeService from "@/service/atividadeService";
import acaoService from "@/service/acaoService";
import tarefaService from "@/service/tarefaService";
import router from "@/router";
import Aviso from "@/components/common/aviso.vue";
import ModalDeConfirmacao from "@/components/common/modalDeConfirmacao.vue";

const props = defineProps({
  acaoId: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["fechar-form-tarefa"]);

const textosAjuda = [
  "Informe um título claro e objetivo para a tarefa. Exemplos: 'Diagramar apostila de POO', 'Criar logotipo da ação'.",
  "Descreva o conteúdo completo da tarefa. Inclua informações relevantes, o que será importatnte nessa tarefa",
  "Data de Início da tarefa e fim, as pessoas só poderam trabalhar na tarefa dentro desse intervalo",
  "Data de Início da tarefa e fim, as pessoas só poderam trabalhar na tarefa dentro desse intervalo",
  "Defina o grau de importância de conclusão para atividade, quanto maior a prioridade mais rápido a tarefa deve ser concluída",
  "Selecione quem poderá trabalhar dentro desta tarefa. Se houver atividade vinculada, os membros da equipe da atividade estarão disponíveis para seleção.",
  "Se esta tarefa tem ligação com uma atividade, selecione-a aqui. Caso contrário, deixe em branco.",
  "Em que status está a tarefa, se poderá ser respondida, ou informa que está em edição.",
  "Tempo em horas que o coordenador estima para que a tarefa possa ser concluída",
];

const prioridades = ref([]);
const integrantesAcao = ref([]);
const integranteSelecionado = ref({});
const atividadesAcao = ref([]);
const tempoEstimado = ref(0);
const equipe = ref([]);
const membrosSelecionados = ref([]);
const aviso = ref(false);
const texto = ref("");
const sucesso = ref(false);
const criarTarefa = ref(false);
const confirmacaoView = ref(false);
const acaoFormulario = ref("");

const tarefa = ref({
  titulo: "",
  descricao: "",
  dataInicio: "",
  dataFim: "",
  tempoEstimado: 0,
  prioridade: {
    id: "",
  },
  listaUsuarios: [],
  atividadeId: "",
});
function fecharForm() {
  router.push(-1);
}
// Computed para integrantes disponíveis (quando não há atividade vinculada)
const integrantesDisponiveis = computed(() => {
  return integrantesAcao.value.filter(
    (integrante) =>
      !tarefa.value.listaUsuarios.some((user) => user.id === integrante.id)
  );
});

function confirmacao(confirmacao) {
  criarTarefa.value = confirmacao;
  confirmacaoView.value = false;
  cadastrarTarefa(acaoFormulario.value);
}

async function buscarEquipe() {
  if (!tarefa.value.atividadeId) {
    equipe.value = [];
    membrosSelecionados.value = [];
    return;
  }

  try {
    const response = await atividadeService.getGrupoAtividade(
      tarefa.value.atividadeId
    );
    if (response.status === 200) {
      response.data.Membros.filter((membro) => {
        integrantesAcao.value.map((membroAcao) => {
          if (membroAcao.nome == membro.nome) {
            equipe.value.push(membroAcao);
          }
        });
      });
      // Inicializa os membros selecionados com os já alocados na atividade
      membrosSelecionados.value = tarefa.value.listaUsuarios
        .filter((user) => equipe.value.some((membro) => membro.id === user.id))
        .map((user) => user.id);
    } else {
      if (response.status == 404) {
        alert("Grupo não encontrado, aloque pessoas da ação!");
      } else {
        alert("Erro desconhecido, tente novamente!");
      }
      equipe.value = [];
    }
  } catch (error) {
    console.error("Erro ao buscar equipe:", error);
    console.log(error);
    equipe.value = [];
  }
}

function onAtividadeChange() {
  buscarEquipe();
  // Limpa a lista de usuários quando muda a atividade
  tarefa.value.listaUsuarios = [];
  membrosSelecionados.value = [];
}

function removerAtividadeVinculada() {
  tarefa.value.atividadeId = "";
  equipe.value = [];
  membrosSelecionados.value = [];
  tarefa.value.listaUsuarios = [];
}

function atualizarMembrosDaAtividade() {
  // Atualiza a lista de usuários com base nos checkboxes selecionados
  tarefa.value.listaUsuarios = equipe.value
    .filter((membro) => membrosSelecionados.value.includes(membro.id))
    .map((membro) => ({ id: membro.id, nome: membro.nome }));
}

function adicionarIntegrante() {
  if (integranteSelecionado.value.id) {
    tarefa.value.listaUsuarios.push({
      id: integranteSelecionado.value.id,
      nome: integranteSelecionado.value.nome,
    });
    integranteSelecionado.value = {};
  }
}

function removerIntegrante(index) {
  tarefa.value.listaUsuarios.splice(index, 1);
}
function confirmacaoInicial(acaoForm) {
  acaoFormulario.value = acaoForm;
  texto.value = "Deseja realmente criar a tarefa?";
  confirmacaoView.value = true;
}
async function cadastrarTarefa() {
  // Validação básica
  if (!criarTarefa.value) {
    sucesso.value = false;
    texto.value = "Tarefa não foi criada!";
    aviso.value = true;
    return;
  }
  // if (tarefa.value.listaUsuarios.length === 0) {
  //   texto.value = "Selecione pelo menos um responsável para a tarefa.";
  //   aviso.value = true;
  //   return;
  // }
  tarefa.value.tempoEstimado = tempoEstimado.value * 60;

  if (!tarefa.value.atividadeId) {
    tarefa.value.acaoId = props.acaoId;
  }

  const operacao = acaoFormulario.value === "enviar" ? "ENVIAR" : "GRAVAR";
  const usersTarefa = tarefa.value.listaUsuarios.map((user) => user.id);

  const dadosTarefa = {
    ...tarefa.value,
    listaUsuarios: usersTarefa,
  };
  try {
    const response = await tarefaService.postTarefa(dadosTarefa, operacao);
    if (response.status === 201) {
      texto.value = "Tarefa criada com sucesso!";
      sucesso.value = true;
      aviso.value = true;
    } else {
      texto.value = response.data.message;
      sucesso.value = false;
      aviso.value = true;
    }
  } catch (error) {
    if (error.response?.status === 403) {
      alert(error.data.message);
    } else {
      const erros =
        error.response?.data?.errors
          ?.map((error) => error.message)
          .join(", ") || "Erro desconhecido";
      alert(`Erros ao cadastrar tarefa: ${erros}`);
    }
  }
}

onMounted(async () => {
  document.body.classList.add("modal-aberto");

  try {
    // integrantesAcao.value = await acaoService.getMembrosTime(props.acaoId);
    integrantesAcao.value = await acaoService.getIndiceDeCarga(
      props.acaoId,
      "LEVE"
    );
    const response = await atividadeService.getAtividadesAcao(
      0,
      1000,
      props.acaoId
    );
    atividadesAcao.value = response.filter(
      (atividade) => atividade.acaoUrl.split("/").pop() == props.acaoId
    );
    prioridades.value = await tarefaService.getPrioridadeTarefa();
  } catch (error) {
    console.error("Erro ao carregar dados:", error);
  }
});

onBeforeUnmount(() => {
  document.body.classList.remove("modal-aberto");
});
</script>

<style scoped>
.mb-3 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.campos-form {
  padding-bottom: 40px;
}

#atividade-vinculada {
  flex: 1;
}

#remover-atividade {
  background-color: var(--vermelho);
  color: var(--branco);
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
}

.grupo-atividade {
  margin-top: 10px;
  width: 100%;
}

.membros-lista {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.membro-item {
  display: flex;
  align-items: center;
}

.membro-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.membro-checkbox input[type="checkbox"] {
  margin: 0;
}

.info-selecionados {
  margin-top: 10px;
  padding: 8px;
  background-color: var(--cinza-claro);
  border-radius: 4px;
  font-size: 0.9em;
}

.lista-membros-selecionados {
  margin-top: 15px;
}

.lista-membros-selecionados h6 {
  margin-bottom: 10px;
  color: var(--cinza-escuro);
}

.integrante-selecionado {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px;
  border-radius: 5px;
  border-bottom: 2px solid hsla(0, 0%, 0%, 0.186);
}

#adicionar-integrante {
  background-color: var(--roxo-primario);
  color: var(--branco);
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
}

#adicionar-integrante:disabled {
  background-color: var(--cinza-claro);
  cursor: not-allowed;
}

.remover-integrante {
  background-color: var(--vermelho);
  color: var(--branco);
  border: none;
  padding: 5px 10px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.8em;
}
</style>
